<template>
    <div>
		<img src="../assets/img/detail/yhw/1.jpg" width="100%" />
		<img src="../assets/img/detail/yhw/2.jpg" width="100%"/>
		<img src="../assets/img/detail/yhw/3.jpg" width="100%"/>
		<img src="../assets/img/detail/yhw/4.jpg" width="100%"/>
		<img src="../assets/img/detail/yhw/5.jpg" width="100%"/>
		<img src="../assets/img/detail/yhw/6.jpg" width="100%"/>
		<img src="../assets/img/detail/yhw/7.jpg" width="100%"/>
		<img src="../assets/img/detail/yhw/8.jpg" width="100%"/>
		<img src="../assets/img/detail/yhw/9.jpg" width="100%"/>
		<img src="../assets/img/detail/yhw/10.jpg" width="100%"/>
		<img src="../assets/img/detail/yhw/11.jpg" width="100%"/>
		<img src="../assets/img/detail/yhw/12.jpg" width="100%"/>
		<img src="../assets/img/detail/yhw/13.jpg" width="100%"/>
		<img src="../assets/img/detail/yhw/14.jpg" width="100%"/>
		<img src="../assets/img/detail/yhw/15.jpg" width="100%"/>
		<img src="../assets/img/detail/yhw/16.jpg" width="100%"/>
		<img src="../assets/img/detail/yhw/17.jpg" width="100%"/>
		<img src="../assets/img/detail/yhw/18.jpg" width="100%"/>
    </div>
</template>

<script>
    export default {
        name: 'Product_sswm',
        data: function () {
            return {
            }
        },
        mounted: function () {

        },
        created: function () {

        },
        methods: {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>